module.exports = __webpack_public_path__ + "img/risk_yes_no.0196bfa5.png";